var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.contact
    ? _c("div", { staticClass: "card card-body" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-5" }, [_vm._v("Ansprechpartner")]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-7 customer-data" }, [
            _vm._v(_vm._s(_vm.contact.name)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-5" }, [_vm._v("E-Mail-Adresse(n)")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-7 customer-data-ff" },
            _vm._l(_vm.emails, function (email) {
              return _c("div", [
                _c("a", { attrs: { href: "mailto:" + email } }, [
                  _vm._v(_vm._s(email)),
                ]),
              ])
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-5" }, [_vm._v("Telefon")]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-7 customer-data-ff" }, [
            _vm._v(_vm._s(_vm.contact.phone)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-5" }, [_vm._v("Organisation")]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-7 customer-data-ff" }, [
            _vm._v(_vm._s(_vm.contact.org)),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }